import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setAuthUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('No session_id found in hash:', hash);
          navigate('/login');
          return;
        }

        console.log('Exchanging session_id...');

        // Exchange session_id for session token
        const response = await axios.post(
          `${API_URL}/api/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        console.log('Session exchange successful');

        // Set user in context and redirect
        setAuthUser(response.data);
        
        // Clear the hash and navigate to dashboard
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard', { replace: true, state: { user: response.data } });
      } catch (error) {
        console.error('Auth callback error:', error?.response?.data || error?.message || error);
        // Try one more time after a short delay
        try {
          const hash = window.location.hash;
          const params = new URLSearchParams(hash.substring(1));
          const sessionId = params.get('session_id');
          if (sessionId) {
            console.log('Retrying session exchange...');
            await new Promise(r => setTimeout(r, 1000));
            const response = await axios.post(
              `${API_URL}/api/auth/session`,
              { session_id: sessionId },
              { withCredentials: true }
            );
            setAuthUser(response.data);
            window.history.replaceState(null, '', '/dashboard');
            navigate('/dashboard', { replace: true, state: { user: response.data } });
            return;
          }
        } catch (retryError) {
          console.error('Retry also failed:', retryError?.response?.data || retryError?.message);
        }
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate, setAuthUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-sky-400 rounded-2xl mb-4 animate-pulse">
          <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <circle cx="12" cy="12" r="10" strokeWidth="2" />
          </svg>
        </div>
        <p className="text-slate-500">Accesso in corso...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
